import React from 'react';
import { AppPage, MimaButton, PageLoader, Searchbar } from '../../components';
import styles from '../../assets/styles/BusinessCategory/BusinessCategory.module.scss';
import { AnimatePresence } from 'framer-motion';
import MimaOptionMenu from '../../components/OptionMenu';
import { useState } from 'react';
import { AddFaqCategoryContainer, DeleteFaqCategoryContainer, EditFaqCategoryContainer } from '../../containers';

const FaqsCategory = ({
    deleteCategoryModal,
    goToDeleteCategoryModal,
    loading,
    goToAddCategoryModal,
    addCategoryModal,
    closeModal,
    goToEditCategoryModal,
    editCategoryModal,
    faqsCategory,
}) => {
    const [filteredFaqCategories, setFilteredFaqCategories] = useState([]);
    const [data, setData] = useState({});

    const filterDeletedFaqCategories = faqsCategory.filter(x => x.status.toString() === "true")

    return (
        <AppPage pageTitle="FAQs Category">
            {loading ? (
                <PageLoader title="while we load your information" />
            ) : (
                <div>
                    <div className={styles.searchMidle}>
                        <Searchbar
                            variant="regular"
                            placeholder="Search"
                            height={5}
                            input={filterDeletedFaqCategories}
                            output={setFilteredFaqCategories}
                            handleFilter={(item, searchQuery) => {
                                return item?.name.toLowerCase()?.includes(searchQuery)
                            }}
                        />
                        <MimaButton
                            title="Add Category"
                            width={38}
                            onClick={() => {
                                setData()
                                goToAddCategoryModal();
                            }}
                        />
                    </div>

                    <div className='whiteTable'>
                        <table>
                            <thead>
                                <tr>
                                    <th>Category</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredFaqCategories.map(category => (
                                    <tr key={category._id}>
                                        <td>{category.name}</td>
                                        <td>
                                            <div className='tableAction__text'>
                                                <MimaOptionMenu
                                                    options={[
                                                        {
                                                            label: "Edit",
                                                            value: "EDIT"
                                                        },
                                                        {
                                                            label: "Delete",
                                                            value: "DELETE"
                                                        }
                                                    ]}
                                                    onOptionSelected={option => {
                                                        setData(category);
                                                        if (option.value === "EDIT") {
                                                            goToEditCategoryModal();
                                                        } else if (option.value === "DELETE") {
                                                            goToDeleteCategoryModal()
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {(addCategoryModal ||
                        editCategoryModal ||
                        deleteCategoryModal) && (
                            <di className="modal">
                                <AnimatePresence>
                                    {addCategoryModal && (
                                        <AddFaqCategoryContainer
                                            closeModal={closeModal}
                                            data={data}
                                        />
                                    )}
                                    {editCategoryModal && (
                                        <EditFaqCategoryContainer
                                            closeModal={closeModal}
                                            data={data}
                                        />
                                    )}
                                    {deleteCategoryModal && (
                                        <DeleteFaqCategoryContainer
                                            closeModal={closeModal}
                                            data={data}
                                        />
                                    )}
                                </AnimatePresence>
                            </di>

                        )}
                </div>
            )}
        </AppPage>
    )
}
export default FaqsCategory;